import { render, staticRenderFns } from "./textGenerate.vue?vue&type=template&id=134afa62&scoped=true&"
import script from "./textGenerate.ts?vue&type=script&lang=js&"
export * from "./textGenerate.ts?vue&type=script&lang=js&"
import style0 from "./textGenerate.less?vue&type=style&index=0&id=134afa62&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134afa62",
  null
  
)

export default component.exports